// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"87":"f001389c73d093df","185":"b2b39b912ce42fb8"}[chunkId] + ".css";
};